var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheck = function SvgCheck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.54988 15.5154L18.1884 6.87692C18.3371 6.72821 18.5137 6.65224 18.7182 6.64902C18.9226 6.64582 19.1024 6.72179 19.2576 6.87692C19.4127 7.03204 19.4903 7.21024 19.4903 7.41152C19.4903 7.61279 19.4127 7.79099 19.2576 7.94612L10.1826 17.0211C10.0018 17.2019 9.7909 17.2922 9.54988 17.2922C9.30887 17.2922 9.09798 17.2019 8.91721 17.0211L4.74221 12.8461C4.59349 12.6974 4.52009 12.5208 4.52201 12.3163C4.52394 12.1118 4.60247 11.932 4.75758 11.7769C4.91272 11.6218 5.09092 11.5442 5.29218 11.5442C5.49347 11.5442 5.67167 11.6218 5.82678 11.7769L9.54988 15.5154Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "check.f4f7d4065ca4d2c5cb9c36c6ffc4d3bf.svg";